import { render, staticRenderFns } from "./IndexTrade.vue?vue&type=template&id=4dbd8d79&scoped=true&"
import script from "./IndexTrade.vue?vue&type=script&lang=js&"
export * from "./IndexTrade.vue?vue&type=script&lang=js&"
import style0 from "./IndexTrade.vue?vue&type=style&index=0&id=4dbd8d79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbd8d79",
  null
  
)

export default component.exports